"use client";
import React, { createContext, useContext, useState } from "react";
import { AppContext } from "./AppContext";

const MenuContextQuickCryptoForm = createContext();

export const MenuProviderQuickCryptoForm = ({ children }) => {
  const { user, setIsClosed } = useContext(AppContext);
  const [isCryptoFormOpen, setIsCryptoFormOpen] = useState(false);

  const openCryptoForm = () => {
    if (!user) {
      setIsClosed(false);
      return;
    }
    setIsCryptoFormOpen(true);
    Tawk_API.hideWidget();
  };

  const closeCryptoForm = () => {
    setIsCryptoFormOpen(false);
    Tawk_API.showWidget();
  };

  return (
    <MenuContextQuickCryptoForm.Provider
      value={{ isCryptoFormOpen, openCryptoForm, closeCryptoForm }}
    >
      {children}
    </MenuContextQuickCryptoForm.Provider>
  );
};

export const useMenuQuickCryptoForm = () => {
  return useContext(MenuContextQuickCryptoForm);
};
